// Helpers de presentación para plantillas de notificación.
// Fuente: api-reference/admin-notifications.md + admin-tasks.md (canal twilio).

// La lista puede llegar como array pelado o como { items, pagination } — toleramos ambas.
export function templateItems(data) {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.items)) return data.items;
    return [];
}

export function templateTotal(data, fallbackCount) {
    return data?.pagination?.total ?? fallbackCount;
}

// El contrato solo documenta status=0 (archivado, soft-delete). El entero "activo"
// no está documentado, así que NO lo asumimos: activo = "no es 0".
export function isArchived(t) {
    return Number(t?.status) === 0;
}

// Valor del campo `channel` validado por el backend (enum). Único permitido hoy:
// WHATSAPP (el "twilio" del contrato es el nombre del canal en el dispatcher interno,
// no el valor de este campo). Dejamos el select por si suman canales más adelante.
export const DEFAULT_CHANNEL = 'WHATSAPP';

export const CHANNEL_OPTIONS = [
    ['WHATSAPP', 'WhatsApp'],
];

export const CHANNEL_LABEL = Object.fromEntries(CHANNEL_OPTIONS);
